import { render, staticRenderFns } from "./hostManage.vue?vue&type=template&id=08dacdda&"
import script from "./hostManage.vue?vue&type=script&lang=js&"
export * from "./hostManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports